// src/components/NovoFooter.tsx
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import { Link } from 'react-router-dom';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import qrCode from '../assets/thumbnail_banner_qrcode-FACULDADE.jpg';

const NovoFooter: React.FC = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #1d2671, #c33764)',
        color: '#fff',
        pt: 6,
        pb: 4,
        mt: 8,
        fontFamily: 'Inter, sans-serif',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Informações Senac */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom>
              FACULDADE SENAC AMAZONAS
            </Typography>
            <Typography variant="body2">CNPJ: 03.965.450/0001-07</Typography>
            <Typography variant="body2">Rua 10 de Julho, 11 - Centro</Typography>
            <Typography variant="body2">Manaus - AM, CEP: 69010-060</Typography>
          </Grid>

          {/* Logos */}
          <Grid item xs={12} sm={6} md={2}>
            <Box display="flex" gap={2} alignItems="center" justifyContent="center" flexWrap="wrap">
              <Box
                component="img"
                src="/logo-integrada.png"
                alt="Logo Senac"
                sx={{ height: 140, filter: 'brightness(0) invert(1)' }}
              />
            </Box>
          </Grid>

          {/* QR Code */}
          <Grid item xs={12} sm={6} md={2} textAlign="center">
            <Typography variant="subtitle1">Selo E-MEC</Typography>
            <Box
              component="img"
              src={qrCode}
              alt="QR Code"
              sx={{ width: 100, borderRadius: 2, mt: 1 }}
            />
          </Grid>

          {/* Links Úteis */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>Links Úteis</Typography>
            <Box sx={linkStyle} component={Link} to="../assets/docs/secad/Calendário Acadêmico 2025_2 1.pdf">Calendário Acadêmico</Box>
            <Box sx={linkStyle} component={Link} to="/biblioteca/ambiente">Biblioteca</Box>
            <Box sx={linkStyle} component={Link} to="https://cachola.senac.br/?locale=pt">Cachola</Box>
            <Box sx={linkStyle} component={Link} to="/revista">Revista</Box>
            <Box sx={linkStyle} component={Link} to="/secretaria/monitoria">Monitoria</Box>
            <Box sx={linkStyle} component={Link} to="/faq">Dúvidas Frequentes</Box>
          </Grid>

          {/* Políticas */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" gutterBottom>Política</Typography>
            <Box sx={linkStyle} component={Link} to="/politica-privacidade">Privacidade</Box>
            <Box sx={linkStyle} component={Link} to="/politica-cookies">Cookies</Box>
            <Box sx={linkStyle} component={Link} to="/lgpd">LGPD</Box>
          </Grid>
        </Grid>

        {/* Redes e Mapa */}
        <Grid container spacing={4} mt={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Redes Sociais</Typography>
            <Box display="flex" gap={2}>
              <IconButton aria-label="Facebook" color="inherit" href="https://facebook.com" target="_blank">
                <FacebookIcon />
              </IconButton>
              <IconButton aria-label="Instagram" color="inherit" href="https://instagram.com" target="_blank">
                <InstagramIcon />
              </IconButton>
              <IconButton aria-label="LinkedIn" color="inherit" href="https://linkedin.com" target="_blank">
                <LinkedInIcon />
              </IconButton>
              <IconButton aria-label="YouTube" color="inherit" href="https://youtube.com" target="_blank">
                <YouTubeIcon />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" gutterBottom>Como chegar</Typography>
            <Box
              component="iframe"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3974.157889453917!2d-60.02572992417667!3d-3.131866896842659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x926c1bcf64823dbd%3A0x37a5aeb5e89486fa!2sFaculdade%20Senac%20AM!5e0!3m2!1spt-BR!2sbr!4v1712708029285!5m2!1spt-BR!2sbr"
              width="100%"
              height="150"
              loading="lazy"
              style={{ border: 0, borderRadius: '8px' }}
              title="Mapa de localização"
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />

        <Box textAlign="center" fontSize="0.85rem">
          &copy; {new Date().getFullYear()} SENAC. Todos os direitos reservados.
        </Box>

        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            background: '#ff6b6b',
            color: '#fff',
            borderRadius: '50%',
            width: 48,
            height: 48,
            boxShadow: 3,
            '&:hover': {
              background: '#ffa502',
              transform: 'translateY(-2px)',
            },
          }}
          aria-label="Voltar ao topo"
        >
          <KeyboardArrowUpIcon />
        </IconButton>
      </Container>
    </Box>
  );
};

const linkStyle = {
  display: 'block',
  color: '#f1f1f1',
  textDecoration: 'none',
  fontSize: '0.95rem',
  mt: 0.5,
  '&:hover': {
    color: '#fca138',
  },
};

export default NovoFooter;
